import React, {useContext} from 'react';
import CountUp from "react-countup";
import VisibilitySensor from 'react-visibility-sensor';
import Themes from 'themes';
import './index.css';
const ThemeContext = React.createContext(Themes.themes1);

const CountUp001 = () => {
  const entryType = [
    {key:0, end: 9, aniCount: 'aniCount1'},{key:1, end: 2, aniCount: 'aniCount2'},{key:2, end: 7, aniCount: 'aniCount3'},{key:3, end: 4, aniCount: 'aniCount4'},{key:4, end: 1, aniCount: 'aniCount5'},{key:5, end: 2, aniCount: 'aniCount6'},{key:6, end: 7, aniCount: 'aniCount7'},{key:7, end: 8, aniCount: 'aniCount8'}
  ]
  const Themes = useContext(ThemeContext);

  return(
    <div className="count001" style={{ backgroundImage: Themes.count001 }}>
    {entryType.map(({key, end, aniCount }) => <CountUp
      start={0}
      end={end}
      duration={20}
      separator=" "
      decimals={0}
      delay={1}
      redraw={true}
      key={key}
    >
      {({ countUpRef, start }) => (
        <VisibilitySensor onChange={start} partialVisibility={true} offset={{ top: 10 }}>
           <div className="countBox001" style={{ backgroundImage: Themes.countBox001 }} >
              <span ref={countUpRef} className={aniCount} />
           </div>
        </VisibilitySensor>
      )}
    </CountUp>)}
  </div>
  )
}

export default CountUp001
